import Payment from '@/models/payment'

import PassengerExtra from './passenger-extra'

export default interface Passenger {
  id: number
  bookingId?: string
  totalPriceCents: number
  unitPriceCents: number
  amountPaidCents: number
  remainingAmountCents: number
  depositOutstandingCents: number
  fullName: string
  deck: TransportSuboptions
  shipType: string
  firstName: string
  lastName: string
  email?: string
  customerId?: number
  partnerId?: number
  payments?: Payment[]
  createdAt: string
  passengerExtras: PassengerExtra[]
  title?: string
  tel?: string
  countryCode?: string
  age: number | null
  nationality?: string
  passengerStatus: PassengerStatuses
  thumbAvatarUrl?: string
  largeAvatarUrl?: string
  cancellationFeeCents: number
  canBeChanged: boolean
  personalInfoStatus?: PassengerInfoStatuses
}

export enum PassengerStatuses {
  Unpaid = 'unpaid',
  Pending = 'pending',
  Confirmed = 'confirmed',
  Cancelled = 'cancelled',
}

export enum PassengerInfoStatuses {
  Complete = 'complete',
  Partial = 'partial',
  Empty = 'empty',
}

export enum TransportSuboptions {
  AboveDeck = 'Above Deck',
  LowerDeck = 'Lower Deck',
  Default = 'Default',
}
